/**
 * Hub URLs for the Scrips real-time surfaces. Same path-shape as
 * Flutter's `signalRHub(SignalRService.<name>)` family.
 *
 * **All URLs are relative paths** so dev/prod resolve through the
 * configured API base — the Vite proxy in dev or VITE_API_BASE_URL
 * in prod. No environment-specific hardcoding.
 *
 * The `createHubConnection` factory now lives in `@/shared/realtime/...`
 * — re-exported here for backwards compatibility with existing imports.
 */
export { createHubConnection } from '@/shared/realtime/signalr-connection';

export const SCHEDULING_HUB_URL =
  '/api/appointment-scheduling-notificationhub/NotificationsHub';
export const PRACTICE_HUB_URL = '/api/practice/NotificationsHub';

/**
 * Patient-encounter hub — Flutter `SignalRService.Encounter`. Carries
 * the patient-scoped real-time events that the chart screen needs
 * (PatientePrescription for meds + D/I, PatientSummaryUpdate for the
 * header bar, etc.). The encounter base is `/api/patient-encounter`.
 */
export const ENCOUNTER_HUB_URL = '/api/patient-encounter/NotificationsHub';

/**
 * Organization-notification hub — Flutter `SignalRService.Macro`
 * (`signalRHub` in `scrips_core/constants/api_constants.dart:555-557`).
 * Carries org-scoped notification events; today only `MacroUpdated`
 * is consumed (fires when any user adds/edits/archives a macro the
 * current practitioner can see). When more org-wide events ship on
 * this hub, each one wires a separate `.on(name, handler)`.
 */
export const ORG_NOTIFICATION_HUB_URL =
  '/api/practice/OrganizationNotificationHub';
